import { render, staticRenderFns } from "./wizard-navigation.vue?vue&type=template&id=51e3cef8&"
import script from "./wizard-navigation.vue?vue&type=script&lang=js&"
export * from "./wizard-navigation.vue?vue&type=script&lang=js&"
import style0 from "./_wizard-navigation.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports